var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { login, startMfa, refresh, finalizeMfa, loginWithAuthorizationCode } from './Api/authBusinessUsersClient';
import Cookies from 'universal-cookie';
var cookie = new Cookies();
var Auth = (function () {
    function Auth() {
    }
    Auth.isLoggedIn = function (api, domain) {
        return this.load(Auth.accessTokenName) ?
            Promise.resolve(true) :
            this.refreshAccessToken(api, this.load(Auth.refreshTokenName), domain);
    };
    Auth.login = function (username, password, domain, api) {
        var _this = this;
        return login(api, username, password).then(function (res) {
            var loggedIn = res.status === 201;
            var mfaRequired = !!res.data && res.data.status === 'mfa-required';
            var mfaPendingCredential = res.data ? res.data.mfaPendingCredential : null;
            var mfaEnrollmentId = res.data ? res.data.mfaEnrollmentId : null;
            var phoneNumber = res.data ? res.data.phoneNumber : null;
            if (loggedIn) {
                _this.saveTokens(res.data, domain);
            }
            return Promise.resolve({ loggedIn: loggedIn, mfaRequired: mfaRequired, mfaPendingCredential: mfaPendingCredential, mfaEnrollmentId: mfaEnrollmentId, phoneNumber: phoneNumber });
        })
            .catch(function () { return Promise.resolve({ loggedIn: false, mfaRequired: false, mfaPendingCredential: '', mfaEnrollmentId: '', phoneNumber: '' }); });
    };
    Auth.loginWithAuthorizationCode = function (code, domain, api) {
        var _this = this;
        return loginWithAuthorizationCode(api, code).then(function (res) {
            var loggedIn = res.status === 201;
            if (loggedIn) {
                _this.saveTokens(res.data, domain);
            }
            return Promise.resolve({ loggedIn: loggedIn });
        })
            .catch(function () { return Promise.resolve({ loggedIn: false }); });
    };
    Auth.startMfa = function (mfaPendingCredential, mfaEnrollmentId, recaptchaToken, api) {
        return startMfa(api, mfaPendingCredential, mfaEnrollmentId, recaptchaToken).then(function (res) {
            return Promise.resolve({ error: res.data.error || null, sessionInfo: res.data.sessionInfo || null });
        })
            .catch(function (err) { return Promise.resolve({ error: err.response.data.error || 'UNKNOWN_ERROR', sessionInfo: '' }); });
    };
    Auth.finalizeMfa = function (mfaPendingCredential, sessionInfo, verificationCode, domain, api) {
        var _this = this;
        return finalizeMfa(api, mfaPendingCredential, sessionInfo, verificationCode).then(function (res) {
            var loggedIn = res.status === 200;
            if (loggedIn) {
                _this.saveTokens(res.data, domain);
            }
            return Promise.resolve({ loggedIn: loggedIn, error: '' });
        })
            .catch(function (err) { return Promise.resolve({ loggedIn: false, error: err.response.data.error || 'UNKNOWN_ERROR' }); });
    };
    Auth.getAccessToken = function () {
        return Auth.load(Auth.accessTokenName) || Auth.accessToken;
    };
    Auth.removeTokens = function (domain) {
        Auth.remove(Auth.accessTokenName, { domain: domain, sameSite: 'none', secure: true });
        Auth.remove(Auth.refreshTokenName, { domain: domain, sameSite: 'none', secure: true });
    };
    Auth.refreshAccessToken = function (api, refreshToken, domain) {
        var _this = this;
        if (refreshToken) {
            return refresh(api, refreshToken).then(function (res) {
                if (res.status === 201 && Auth.load(Auth.refreshTokenName)) {
                    _this.saveTokens(res.data, domain);
                    return Promise.resolve(true);
                }
                return Promise.resolve(false);
            })
                .catch(function () { return Promise.resolve(false); });
        }
        return Promise.resolve(false);
    };
    Auth.saveTokens = function (data, domain) {
        var options = {
            path: '/',
            domain: domain,
            sameSite: 'none',
            secure: true
        };
        Auth.save(Auth.accessTokenName, data.accessToken, __assign(__assign({}, options), { maxAge: data.expiresIn }));
        Auth.save(Auth.refreshTokenName, data.refreshToken, options);
        Auth.accessToken = data.accessToken;
    };
    Auth.load = function (name) {
        return cookie.get(name);
    };
    Auth.save = function (name, value, options) {
        if (options === void 0) { options = {}; }
        cookie.set(name, value, options);
    };
    Auth.remove = function (name, options) {
        if (options === void 0) { options = {}; }
        cookie.remove(name, options);
    };
    Auth.accessTokenName = 'tp-b2b-access-token';
    Auth.refreshTokenName = 'tp-refresh-token';
    Auth.accessToken = '';
    return Auth;
}());
export { Auth };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/Auth.js
// module id = 147
// module chunks = 0